var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-center"},[_c('div',{ref:"chart",staticClass:"chart-container",attrs:{"id":"call-length-chart"}})]),_c('ChartLegend',{attrs:{"items":_vm.legend}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }